import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import moment from 'moment';
import useFormValidator from 'useFormValidator';
import Uploader from 'modules/common/components/Uploader';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { customStyle } from 'helper';
import { ModalContext } from 'App';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as actions from '../../../action';
import * as c from '../../../constant';
import PaymentComponent from '../components/PaymentComponent';

// const years = _.range(2000, 2030).sort(
//   (a, b) => b - a
// );

const quarters = [
  { value: 1, label: '1st Quarter' },
  { value: 2, label: '2nd Quarter' },
  { value: 3, label: '3rd Quarter' },
  { value: 4, label: '4th Quarter' },
]

function PaymentHistoryModal({
  applicationInfo,
  applicationId,
  manualPosting,
  history,
  getPaymentHistoryList,
  landTransactionList,
  getPaidLandTransactionList,
  actualUseList,
}) {
  const [transactionOptions, setTransactionOptions] = useState([])
  const [formData, setFormData] = useState({
    year: '',
    qtr: '',
    reason: '',
    reference_url: '',
    reference_no: '',
    or_no: '',
    paid_at: '',
    tax_payer: '',
    rptax_land_transaction_id: '',
  });

  const commonValidation = {
    year: 'required',
    qtr: 'required',
    reason: 'required',
    reference_url: 'required',
    reference_no: 'required',
    or_no: 'required',
    paid_at: 'required',
    tax_payer: 'required',
  }

  const validateForm = useFormValidator(
    formData,
    commonValidation,
  );

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const setModal = useContext(ModalContext);
  const years = _.range(_.get(applicationInfo, 'attributes.effectivity_of_assessment_reassessment_yr'), new Date().getFullYear() + 1)

  const getQuarter = (e) => {
    let options = '';
    switch (e) {
      case '1':
        options = [
          { value: 1, label: '1st Quarter' },
          { value: 2, label: '2nd Quarter' },
          { value: 3, label: '3rd Quarter' },
          { value: 4, label: '4th Quarter' },
        ];
        break;
      case '2':
        options = [
          { value: 2, label: '2nd Quarter' },
          { value: 3, label: '3rd Quarter' },
          { value: 4, label: '4th Quarter' },
        ];
        break;
      case '3':
        options = [
          { value: 3, label: '3rd Quarter' },
          { value: 4, label: '4th Quarter' },
        ];
        break;
      case '4':
        options = [
          { value: 4, label: '4th Quarter' },
        ];
        break;
      default:
        options = [
          { value: 1, label: '1st Quarter' },
          { value: 2, label: '2nd Quarter' },
          { value: 3, label: '3rd Quarter' },
          { value: 4, label: '4th Quarter' },
        ];
        break;
    }
    return options;
  }

  const qtrOptions = _.get(applicationInfo, 'attributes.effectivity_of_assessment_reassessment_yr') === _.get(formData, 'year') ?
    getQuarter(_.get(applicationInfo, 'attributes.effectivity_of_assessment_reassessment_qtr')) :
    quarters

  const yearOptions = years.map((year) => ({
    label: year,
    value: year,
  }));

  useEffect(() => {
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getPaidLandTransactionList(applicationId);
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
    })
    getPaidLandTransactionList(applicationId)
  }, [])

  useEffect(() => {
    setTransactionOptions(
      landTransactionList.map((item) => ({
        label: item.attributes.period,
        value: item.id,
        year: item.attributes.year,
        qtr: item.attributes.qtr,
      }))
    )
  }, [landTransactionList])

  const handleChange = key => data => {
    setFormData({
      ...formData,
      [key]: data,
    });
  };

  const handleOnChange = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
    if (key === 'rptax_land_transaction_id') {
      setFormData({
        ...formData,
        [key]: e.value,
        qtr: e.qtr,
        year: e.year,
      })
    }
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      paid_at: `${moment(_.get(formData, 'paid_at')).format(
        'MM/DD/YYYY'
      )}`,
      reference_url: _.get(formData, 'reference_url'),
    };

    if (_.isEmpty(_.get(formData, 'rptax_land_transaction_id'))) {
      manualPosting(applicationId, _.omit(args, ["year", "qtr"]), () => {
        setModal({ isOpen: false });
        getPaymentHistoryList(applicationId);
        history.push(`/rpt/land/applications/${applicationId}`);
      });
    } else {
      manualPosting(applicationId, args, () => {
        setModal({ isOpen: false });
        getPaymentHistoryList(applicationId);
        history.push(`/rpt/land/applications/${applicationId}`);
      });
    }

  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onChangePhoto = key => ({ cdnUrl }) => {
    setFormData({
      ...formData,
      [key]: cdnUrl,
    });
  };


  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-6">
            <label htmlFor="last_name" className="form-label">Transaction:
            </label>
            <Select
              options={transactionOptions}
              styles={customStyle}
              placeholder="Select Transaction"
              value={transactionOptions?.find(x => x.value === _.get(formData, 'rptax_land_transaction_id'))}
              onChange={handleOnChangeSelect('rptax_land_transaction_id')}
            />
          </div>
          {_.get(formData, 'rptax_land_transaction_id') && (
            <>
              <div className="col-6">
                <label htmlFor="last_name" className="form-label">Year:
                  &nbsp; {validateForm.renderMessage('year')}
                </label>
                <Select
                  isDisabled
                  options={yearOptions}
                  styles={customStyle}
                  placeholder="Select Year"
                  value={yearOptions.find(x => x.value === _.get(formData, 'year'))}
                  onChange={handleOnChangeSelect('year')}
                />
              </div>
              <div className="col-6">
                <label htmlFor="last_name" className="form-label">Quarter:
                  &nbsp; {validateForm.renderMessage('qtr')}
                </label>
                <Select
                  isDisabled
                  options={qtrOptions}
                  styles={customStyle}
                  placeholder="Select Quarter"
                  value={qtrOptions.find(x => x.value === _.get(formData, 'qtr'))}
                  onChange={handleOnChangeSelect('qtr')}
                />
              </div>
            </>
          )}
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-1">
              Reason &nbsp; {validateForm.renderMessage('reason')}
            </label>
            <input
              className="form-control"
              type="text"
              name="reason"
              onChange={onChange}
              value={_.get(formData, 'reason') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label">Upload Reference
              &nbsp; {validateForm.renderMessage('reference_url')}
            </label>
            <div className="row d-flex">
              <div className="col-12">
                <img
                  className="w-100 rounded"
                  src={
                    !_.isObject(
                      _.get(formData, 'reference_url') || ''
                    )
                      ? _.get(formData, 'reference_url') ||
                      ImagePlaceholder
                      : _.get(formData, 'reference_url.cdnUrl') ||
                      ImagePlaceholder
                  }
                  alt=""
                />
              </div>
              <div className='col-6 mt-2'>
                <Uploader
                  className="btn btn-block btn-primary cms-bg-color-primary cms-outline-primary"
                  customLoading={<i className="fas fa-spinner fa-spin" />}
                  icon={<i className="far fa-image" />}
                  label="Upload your reference here"
                  onChange={onChangePhoto('reference_url')}
                />
              </div>
            </div>
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Reference Number &nbsp; {validateForm.renderMessage('reference_no')}
            </label>
            <input
              className="form-control"
              type="text"
              name="reference_no"
              onChange={onChange}
              value={_.get(formData, 'reference_no') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              OR Number &nbsp; {validateForm.renderMessage('or_no')}
            </label>
            <input
              className="form-control"
              type="text"
              name="or_no"
              onChange={onChange}
              value={_.get(formData, 'or_no') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">Paid At:
              &nbsp; {validateForm.renderMessage('paid_at')}
            </label>
            <DateInputPicker
              withTime
              className="full-input"
              onChange={handleOnChange('paid_at')}
              value={_.get(formData, 'paid_at') || ''}
              maxDate={new Date()}
            />
          </div>
          {!_.get(formData, 'rptax_land_transaction_id') && (
            <>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Tax Payer &nbsp; {validateForm.renderMessage('tax_payer')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="tax_payer"
                  onChange={onChange}
                  value={_.get(formData, 'tax_payer') || ''}
                />
              </div>
              <div className="col-12 form-group">
                <label htmlFor="last_name" className="form-label">Payments</label>
              </div>
              <PaymentComponent
                value={formData.payments || []}
                onChange={handleChange("payments")}
                // formData={formData}
                // setFormData={setFormData}
                yearOptions={yearOptions}
                quarters={quarters}
                actualUseList={actualUseList}
                getQuarter={getQuarter}
                applicationInfo={applicationInfo}
              />
            </>
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

PaymentHistoryModal.propTypes = {
  applicationId: PropTypes.string.isRequired,
  getPaymentHistoryList: PropTypes.instanceOf(Function).isRequired,
  applicationInfo: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  manualPosting: PropTypes.instanceOf(Function).isRequired,
  landTransactionList: PropTypes.instanceOf(Array).isRequired,
  getPaidLandTransactionList: PropTypes.instanceOf(Function).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  landTransactionList: _.get(api, `${c.GET_PAID_LAND_TRANSACTION}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PaymentHistoryModal);
